import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '@/components/Logo';
import { BRAND } from '@/lib/constants';
import { Linkedin, Twitter, Youtube, Globe } from 'lucide-react';
import PatronageBlock from '@/components/PatronageBlock';
import AuditIntegrityPill from '@/components/AuditIntegrityPill';

export default function PublicFooter() {
  return (
    <footer className="ve-dark-section ve-grain pt-20 pb-10 text-white/80">
      <div className="ve-container">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="text-white">
              <Logo dark size="lg" />
            </div>
            <p className="mt-5 text-sm text-white/65 max-w-sm leading-relaxed">
              The sovereign-grade governance, risk, audit, and venture platform built for global holdings, regulators, and incubators.
            </p>
            <p className="mt-6 text-xs uppercase tracking-[0.25em] text-white/40">{BRAND.city}</p>
            <div className="mt-6 flex items-center gap-3 text-white/70">
              <a href="#" aria-label="LinkedIn" className="hover:text-white transition-colors"><Linkedin size={18}/></a>
              <a href="#" aria-label="Twitter" className="hover:text-white transition-colors"><Twitter size={18}/></a>
              <a href="#" aria-label="YouTube" className="hover:text-white transition-colors"><Youtube size={18}/></a>
              <a href="#" aria-label="Site" className="hover:text-white transition-colors"><Globe size={18}/></a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.22em] text-white/40">Platform</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/platform" className="hover:text-white">Vigilant One</Link></li>
              <li><Link to="/modules/governance" className="hover:text-white">Governance</Link></li>
              <li><Link to="/modules/risk" className="hover:text-white">Risk</Link></li>
              <li><Link to="/modules/esg" className="hover:text-white">ESG</Link></li>
              <li><Link to="/modules/compliance" className="hover:text-white">Compliance</Link></li>
              <li><Link to="/modules/audit" className="hover:text-white">Audit</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.22em] text-white/40">Solutions</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/solutions" className="hover:text-white">By Role</Link></li>
              <li><Link to="/industries" className="hover:text-white">By Industry</Link></li>
              <li><Link to="/modules/leadership" className="hover:text-white">Build a Board</Link></li>
              <li><Link to="/dashboard/startups" className="hover:text-white">Startup CRM</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.22em] text-white/40">Company</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="#" className="hover:text-white">About</a></li>
              <li><a href="#" className="hover:text-white">Careers</a></li>
              <li><a href="#" className="hover:text-white">Newsroom</a></li>
              <li><Link to="/pricing" className="hover:text-white">Contact Sales</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.22em] text-white/40">Legal</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="#" className="hover:text-white">Privacy</a></li>
              <li><a href="#" className="hover:text-white">Terms</a></li>
              <li><a href="#" className="hover:text-white">SOC 2</a></li>
              <li><a href="#" className="hover:text-white">DPA</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 ve-silver-divider opacity-40" />

        <PatronageBlock variant="dark"/>

        <div className="mt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Vigilant Entities Holding. Part of M3 Holdings Group. All rights reserved.</span>
          <div className="flex items-center gap-3 flex-wrap">
            <AuditIntegrityPill />
            <span className="font-mono">v 1.0 · Sovereign Edition</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
